export const identifyEmailWithClearbit = (email) => {
  if (window.clearbit && window.clearbit.identify) {
    window.clearbit.identify(email, {
      email,
    });
  }
};
